import React, { useMemo } from "react";
import cn from "classnames";
import Lottie from "react-lottie";
import * as dropData from "../assets/lottie/open-cursor.json";
import * as smileData from "../assets/lottie/smile-loop.json";

const Cursor = React.memo(({
  x,
  y,
  mouseDown,
  mouseUp,
  backgroundOver,
  characterOver,
  backdropsOver,
  backdropsOpen,
  remixOver,
  remixOpen
}) => {

  const dropOptions = useMemo(() => ({
    autoplay: true,
    loop: false,
    animationData: dropData.default,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  }), []);

  const smileOptions = useMemo(() => ({
    autoplay: true,
    loop: false,
    animationData: smileData.default,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  }), []);

  return (
    <div className={cn("cursor", {
      visible: backgroundOver || characterOver,
      down: mouseDown,
      up: mouseUp
    })}
      style={{ transform: `translate(${x}px, ${y}px)` }}>
      <div className="cursor__inner">
        <div className="cursor__drop">
          {(backgroundOver || backdropsOver) && <Lottie options={dropOptions}
            height={32}
            width={32}
          />}
          {(characterOver || remixOver) && <Lottie options={smileOptions}
            height={32}
            width={32}
          />}
        </div>
        <div className="cursor__titles">
          <div className={cn("cursor__title", {
            visible: backgroundOver && !backdropsOpen && !remixOpen
          })} title="Backdrops">Backdrops</div>
          <div className={cn("cursor__title", {
            visible: characterOver && !backdropsOpen && !remixOpen
          })} title="Remix">Remix</div>
        </div>
      </div>
    </div>
  );
});

Cursor.displayName = 'Cursor';

export default Cursor;
